import { Gem } from 'lucide-react';
import { useId } from 'react';
import { useTranslations } from 'next-intl';

export const TokenBadge = ({ children }: { children: React.ReactNode }) => {
  const t = useTranslations('Membership.tokenBadge');
  const tooltipId = useId();
  return (
    <button
      type='button'
      className='group focus-visible:ring-primary relative ml-2 flex cursor-default items-center gap-0 rounded-xs border-0 bg-transparent p-1 select-none focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-1'
      aria-label='wild token'
      aria-describedby={tooltipId}
    >
      <Gem height={22} width={22} fill='white' aria-hidden='true' />
      <span
        className='flex h-[22px] items-end pl-1 font-sans text-sm leading-none font-normal'
        aria-live='polite'
      >
        {children}
      </span>
      <div
        id={tooltipId}
        role='tooltip'
        className='border-border bg-background-panel text-text absolute top-full right-0 z-50 mt-2 hidden w-64 max-w-[calc(100vw-1rem)] rounded-sm border px-3 py-2 text-left text-xs text-wrap group-hover:block group-focus-visible:block'
      >
        {t('description')}
      </div>
    </button>
  );
};
